/**
 * Simple logger utility to control console output
 * 
 * This utility can be used to disable console.log, console.warn, console.error
 * statements throughout the application via environment variables
 */

// Get whether logs should be disabled from environment variable
// More reliably check for the env var across different environments
const isLoggingDisabled = 
  process.env.REACT_APP_DISABLE_LOGS === 'true' ||
  (typeof window !== 'undefined' && 
   window._env_ && 
   window._env_.REACT_APP_DISABLE_LOGS === 'true');

// Create a wrapper for console methods
const logger = {
  log: (...args: any[]): void => {
    if (!isLoggingDisabled) {
      console.log(...args);
    }
  },
  
  warn: (...args: any[]): void => {
    if (!isLoggingDisabled) {
      console.warn(...args);
    }
  },
  
  error: (...args: any[]): void => {
    // We typically want to see errors even if regular logs are disabled
    // But we could make this configurable too with a separate env var
    console.error(...args);
  },
  
  info: (...args: any[]): void => {
    if (!isLoggingDisabled) {
      console.info(...args);
    }
  },
  
  debug: (...args: any[]): void => {
    if (!isLoggingDisabled && process.env.NODE_ENV !== 'production') {
      console.debug(...args);
    }
  }
};

export default logger; 